import { CHAT } from '../../analytics';

export const CHAT_TICKETS_PICK_LIMIT = 3;
export const CHAT_TICKETS_SHOW_LIMIT = 10;

export const CHAT_ALL = 'all';
export const CHAT_TICKETS = 'tickets';
export const CHAT_CHAT = 'chat';

export const CHAT_TYPES = [CHAT_ALL, CHAT_TICKETS, CHAT_CHAT];
export const CHAT_TYPES_TRACKING_DATA = {
    [CHAT_ALL]: [CHAT, 'Vsetky spravy v chate', 'Filter'],
    [CHAT_TICKETS]: [CHAT, 'Tikety v chate', 'Filter'],
    [CHAT_CHAT]: [CHAT, 'Diskusia v chate', 'Filter']
};

export const MAX_LENGTH = 500;

export const MAX_BETS_PER_TICKET_DETAIL = 8;

export const CHAT_CLOSED = 'CHAT_CLOSED';
export const CHAT_OPEN = 'CHAT_OPEN';
export const CHAT_MAXIMIZED = 'CHAT_MAXIMIZED';

export const IMPROPER_MESSAGE = ['IMPROPER', 'REMOVED', 'REMOVED_BY_AUTHOR'];

export const searchUrlRegex = /(\b([ A-Za-z0-9\n]+)?(https?):\/\/([a-zA-Z_0-9-.:]+)(\/betbook\/analyzy\/[0-9:]+))/g;
export const searchAnalyseRegex = /\b(https?):\/\/([a-zA-Z_0-9-.:]+)(\/betbook\/analyzy\/[0-9:]+)\/([a-zA-Z_0-9-.:]+)/g;
export const searchAnalyseIdRegex = /(\b\/[0-9:]+\/)/g;
export const searchAnalyseStringRegex = /(\{)\b(Analysis+)([a-zA-Z_0-9-.:]+)(\})/gm;
